
const setVendorStatusMixin = {
    data () {
        return {
            isUserCustomerOrReseller: $store.getters['user-state/isUserCustomer'] || $store.getters['user-state/isUserReseller'],
            isAccountManagerOrCrmOrEmployOrRoot: $store.getters['user-state/isUserAccountManager'] || $store.getters['user-state/isUserPlatformEmployee'] || $store.getters['user-state/isUserCRM'] || $store.getters['user-state/isUserRoot'],
            isEmployOrRoot :  $store.getters['user-state/isUserPlatformEmployee'] || $store.getters['user-state/isUserRoot']
        }
    },
    methods: {
        _canSetBroadcastStatus(broadcast) {
            
            if (
                (broadcast.call_test_status_id == "6" && this.isEmployOrRoot) 
               || (broadcast.call_test_status_id == "2" && this.isAccountManagerOrCrmOrEmployOrRoot) 
             || ((broadcast.call_test_status_id == "1" || (broadcast.is_automated == 1 && broadcast.call_test_status_id == "3")) && !this.isUserCustomerOrReseller)) {
                return true
            }
            return false
        }
    }
};

export default setVendorStatusMixin
